import {useEffect} from 'react';

interface AutoOtpProps {
  setOtp: (code: string) => void;
  onAutoSubmit?: () => void;
  length: number;
}

const AutoOtp = ({setOtp, onAutoSubmit, length}: AutoOtpProps) => {
  useEffect(() => {
    if ('OTPCredential' in window) {
      const ac = new AbortController();

      // auto-cancel after 1–2 minutes
      const timeout = setTimeout(() => ac.abort(), 2 * 60 * 1000);

      navigator.credentials
        .get({
          //@ts-ignore
          otp: {transport: ['sms']},
          signal: ac.signal,
        })
        .then(otp => {
          //@ts-ignore
          const code = otp?.code?.slice(0, length);

          if (code) {
            setOtp(code);
            onAutoSubmit && onAutoSubmit(); // optional auto-submit
          }
        })
        .catch(() => {});

      return () => {
        clearTimeout(timeout);
        ac.abort();
      };
    }
  }, [length, setOtp, onAutoSubmit]);

  return null;
};

export default AutoOtp;
